export class SignatureRequestWithdrawn {
  constructor(referenceId, formSignId) {
    this.referenceId = referenceId;
    this.formSignId = formSignId;
  }
}
